/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { createAsyncThunk } from '@reduxjs/toolkit';

import * as types from './types';
import * as api from './api';

interface GetBuildResponse {
  creation_time: number;
  id: string;
  status: string;
}

export const getBuildByName = createAsyncThunk(
  types.BUILDS_GET,
  (payload: api.GetBuildByNameProps): [GetBuildResponse[], string] => api.getBuildByName(payload)
    .then((data) => {
      const builds = data.builds.sort((buildA, buildB) => (
        buildB.creation_time - buildA.creation_time
      ));
      return [builds, payload.name];
    }),
);
